"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationRules = void 0;
var utils_patterns_1 = __importDefault(require("@techsee/techsee-common/lib/constants/utils.patterns"));
function toValidationJsRegex(regex) {
    return "regex:/".concat(regex.source, "/");
}
exports.ValidationRules = {
    required: function () { return 'required'; },
    minLength: function (val) { return "min:".concat(val); },
    maxLength: function (val) { return "max:".concat(val); },
    phoneNumber: function () { return toValidationJsRegex(utils_patterns_1.default.mobilePhone); },
    password: function () { return toValidationJsRegex(utils_patterns_1.default.password); },
    regexp: function (expression) { return toValidationJsRegex(expression); },
    email: function () { return 'email'; },
    numeric: function () { return 'numeric'; }
};
exports.default = exports.ValidationRules;
